import { Diagnostic, Rule } from "@siteimprove/alfa-act";
import { Err, Ok } from "@siteimprove/alfa-result";
import { Trilean } from "@siteimprove/alfa-trilean";
import { Criterion, Technique } from "@siteimprove/alfa-wcag";
import { expectation } from "../common/act/expectation.js";
import { isPassed } from "../common/act/is-passed.js";
import R22 from "../sia-r22/rule.js";
import R31 from "../sia-r31/rule.js";
import { Scope, Stability } from "../tags/index.js";
export default Rule.Composite.of({
    uri: "https://alfa.siteimprove.com/rules/sia-r27",
    requirements: [
        Criterion.of("1.2.2"),
        Technique.of("G87"),
        Technique.of("G93"),
        Technique.of("H95"),
    ],
    tags: [Scope.Component, Stability.Stable],
    composes: [R22, R31],
    evaluate: () => {
        return {
            expectations(outcomes) {
                return {
                    1: expectation(Trilean.some(outcomes, isPassed), () => Outcomes.HasTextAlternative, () => Outcomes.HasNoTextAlternative),
                };
            },
        };
    },
});
/**
 * @public
 */
export var Outcomes;
(function (Outcomes) {
    Outcomes.HasTextAlternative = Ok.of(Diagnostic.of(`The \`<video>\` element has a text alternative for its audio content`));
    Outcomes.HasNoTextAlternative = Err.of(Diagnostic.of(`The \`<video>\` element has no text alternative for its audio content`));
})(Outcomes || (Outcomes = {}));
//# sourceMappingURL=rule.js.map